import { Button, type ColumnDefinition, Tag } from '@approvalmax/ui/src/components';
import { personSchema } from 'app/(workspace)/[companyId]/wallets/kyc/wizard/personsBasic/resources/schema';
import { PersonFormState } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { getRoles } from '../../../../personsBasic/resources/components/PersonsTable/PersonsTable.helpers';
import { messages } from './VerificationTable.messages';

export const columns: ColumnDefinition<
    z.infer<typeof personSchema> & {
        id: string;
        onOpenDetailsPopup: () => void;
    }
>[] = [
    {
        id: 'name',
        name: messages.name,
        sortable: false,
    },
    {
        id: 'roles',
        name: messages.role,
        sortable: false,
        width: 110,
        value: (item) => getRoles(item.roles),
    },
    {
        id: 'personFormState',
        name: messages.status,
        sortable: false,
        width: 75,
        value: (item) => (
            <Tag
                size='xsmall'
                outline={item.personFormState === PersonFormState.Ready}
                color={item.personFormState !== PersonFormState.Ready ? 'midnight40' : 'green100'}
                title={messages[item.personFormState]}
            >
                {messages[item.personFormState]}
            </Tag>
        ),
    },
    {
        id: 'controls',
        name: messages.verification,
        sortable: false,
        width: 60,
        spacing: '4',
        value: (item) => (
            <Button variant='outline' size='xsmall' onClick={item.onOpenDetailsPopup}>
                {item.personFormState === PersonFormState.InvitationSent ? messages.edit : messages.fillForm}
            </Button>
        ),
    },
];
